export default {
    name: "GraceBound East Africa",
    logo: "/assets/images/gb_icon.png",
    landingImage:{
        imageOld: "/assets/images/mt-ranier.jpg",
        image: "/assets/images/motherland.jpeg",
        imageSm: "/assets/images/motherland.jpeg",
        title: "GRACEBOUND EAST AFRICA",
        slogan: "Serve. Learn. Interact. Grow.",
        alt: "Volunteers and local community members collaborating on a project in East Africa.",
        text: "We provide low-cost, community-based volunteer opportunities across East Africa. Join us to make a meaningful impact while experiencing authentic cultural immersion through local host families."
    },
    mission: {
        title: "OUR MISSION",
        text: "Our mission is to offer transformative opportunities for individuals to serve, interact, and grow through faith-inspired community service. By connecting volunteers with trusted local institutions and families, we ensure an impactful, secure, and deeply enriching program that leaves a lasting legacy."
    },
    aboutUs: {
        title: "Who Are We?",
        text: "We are a Christian-based non-profit organization dedicated to facilitating affordable, impactful volunteer programs across East Africa. While our foundations are rooted in Christian values, we warmly welcome volunteers of all backgrounds who are comfortable serving within faith-based community institutions. What sets us apart is our deep commitment to your well-being: our volunteers live directly with trusted local families, providing authentic cultural exchange at a minimal cost. From arrival to departure, our dedicated team continuously monitors and supports every volunteer, ensuring your journey is safe, rich, and deeply memorable as we work together to make the world a better place.",
        metaDescription: "Discover GraceBound East Africa, a Christian-based non-profit offering affordable, secure, and life-changing volunteer opportunities and host-family stays across East Africa."
    },
    imageSlideShow: [
        {
            original: "/assets/images/serene_manor_front_of_house.png",
            thumbnail: "/assets/images/serene_manor_front_of_house_sm.png",
        },
        {
            original: "/assets/images/serene_manor_entrance.png",
            thumbnail: "/assets/images/serene_manor_entrance_sm.png",
        },
        {
            original: "/assets/images/serene_manor_living_room.png",
            thumbnail: "/assets/images/serene_manor_living_room_sm.png",
        },
        {
            original: "/assets/images/serene_manor_kitchen.png",
            thumbnail: "/assets/images/serene_manor_kitchen_sm.png",
        },
        {
            original: "/assets/images/back_of_home_wide.jpeg",
            thumbnail: "/assets/images/back_of_home_wide_sm.jpeg",
        },
        {
            original: "/assets/images/serene_manor_outside.png",
            thumbnail: "/assets/images/serene_manor_outside_sm.png",
        },
    ],
    serviceTitle: "OUR CORE PROGRAMS",
    serviceCards: [
        {
            title: "Community-Based Volunteering",
            text: "Step into grass-roots development projects designed to uplift local communities. Whether assisting in education, local healthcare initiatives, or community building, your time is channeled into sustainable efforts that address real, localized needs while allowing you to gain practical, hands-on experience."
        },
        {
            title: "Volunteering & Internship Placements",
            text: "Gain purposeful experience through targeted community appointments. We offer diverse opportunities including healthcare, medical, and teaching internships within mission hospitals and schools. Volunteers can also serve in local churches, support community development initiatives, assist at children's centers, or work directly with local women's groups focusing on sustainable crafts like sewing and pottery."
        },
        {
            title: "Authentic Host-Family Immersions",
            text: "Experience East Africa from the inside out. We carefully vet and partner with welcoming local families who open their homes to our volunteers. This low-cost arrangement provides safe housing, home-cooked meals, and unparalleled cross-cultural connection, turning a standard trip into a true home away from home."
        },
        {
            title: "24/7 Continuous Support & Safety",
            text: "Your security and peace of mind are our absolute priorities. Our local coordinators maintain constant, proactive contact with both volunteers and host families, monitoring your well-being at all times. We handle the logistics and safety protocols so you can focus entirely on your journey of growth."
        }
    ],
    sideBySideContent: [
        {
            title: "Where We Operate",
            text: "GraceBound East Africa connects volunteers to impactful programs across key regions, including Nairobi, Nyeri, Nakuru, Mombasa, Watamu, Namanga, and across Maasailand in Kenya; Entebbe and Kampala in Uganda; and Arusha and Moshi in Tanzania.",
            image: "/assets/images/kenya_map_pin_drop.png",
            isImageOnTheLeft: true
        },
        {
            title: "Program Duration & Eligibility",
            text: "Our programs run year-round, offering flexible placements lasting anywhere from 1 to 18 weeks. We welcome volunteers aged 18 and older, as well as younger participants who are accompanied by an adult companion.",            
            image: "/assets/images/duration.png",
            isImageOnTheLeft: false
        }
    ],
    contactDetails: {
        title: "CONTACT DETAILS", 
        phone: "+1 314-591-0743",
        fax: "+1 555-555-5555",
        email: "graceboundea@gmail.com",
        address: "1234 Business address, goes here",
        addressLink: "https://maps.google.com"
    },
    footer: {
        text: "2025 Kode Rush LLC. All rights reserved.",
        socials: [
            // {
            //     icon: "facebook",
            //     link: "https://www.facebook.com/koderushgroup"
            // },
            // {
            //     icon: "twitter",
            //     link: "https://www.twitter.com/"
            // },
            // {
            //     icon: "instagram",
            //     link: "https://www.instagram.com/koderush.io"
            // },
            // {
            //     icon: "linkedin",
            //     link: "https://www.linkedin.com/"
            // },
            // {
            //     icon: "youtube",
            //     link: "https://www.youtube.com/@koderush2925"
            // }
        ]
    }
}